module.exports = "\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.themeheading {\r\n    background: #FFC107;\r\n    color: #000;\r\n}\r\n\r\n.btn-change{\r\n    color: #fff;\r\n    background-color: #F44336;\r\n    border-color: #F44336;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/variable-allowance-deduction-details/variable-allowdeduction/variable-allowdeduction.component.css
// module id = ./src/app/hrms/payroll/variable-allowance-deduction-details/variable-allowdeduction/variable-allowdeduction.component.css
// module chunks = main